module.exports = __webpack_public_path__ + "static/media/icon-black-green.240fc1ef.png";